/**
 * Envío LMX-T · lista de trabajos arriba de la charla de LMX.
 *   «TRABAJOS 2 de 2 · 1 en espera (máx. 3)»
 *   1 Flyers PDLP ×5 · Generando · 3 de 5 listos   [Pausar]
 *   2 Imagen ×4 + texto · Esperando tu OK          [Pausar]
 *   ⏳ Carrusel de 3 placas · En espera              [Quitar]
 * Tocar un trabajo lleva el canvas a su sección.
 */
import React from 'react';
import { jobActions, jobLine, jobProgress, jobsHeader, ACTION_LABEL, ACTIVE } from './trabajos';

export const LmxJobs = ({ snap, runs, onAction, busyIds }) => {
  const list = snap?.jobs || [];
  if (!list.length) return null;
  const full = (snap.active || 0) >= (snap.max_active || 2);
  return (
    <section className="lmx-jobs" aria-label="Trabajos de LMX en este proyecto" data-testid="lmx-jobs">
      <h4>
        <span>Trabajos</span>
        <span className={full ? 'is-full' : ''}>{jobsHeader(snap)}</span>
      </h4>
      {list.map((j) => {
        const progress = jobProgress(j, runs);
        const waiting = j.status === 'en_cola';
        const pct = progress ? Math.round((progress.done / progress.total) * 100) : null;
        const acts = jobActions(j, { canResume: !full });
        return (
          <div key={j.id} className={`lmx-job is-${j.status}`} data-testid={`lmx-job-${j.number}`}>
            <button type="button" className="lmx-job-main"
                    onClick={() => j.section_id && onAction('focus', j)}
                    title={j.section_id ? 'Ver en el canvas' : j.title}>
              <span className="lmx-job-n" style={{ '--job': waiting ? '#3a3d4c' : j.color }}>
                {waiting ? '⏳' : j.number}
              </span>
              <span className="lmx-job-txt">
                <b>{j.title}</b>
                <small>{jobLine(j, progress)}</small>
                {(pct != null || ACTIVE.includes(j.status)) && (
                  <span className="lmx-job-bar" aria-hidden>
                    <i style={{ width: `${pct ?? (j.status === 'esperando' ? 30 : 12)}%`, background: j.color }} />
                  </span>
                )}
              </span>
            </button>
            <span className="lmx-job-acts">
              {acts.map((a) => (
                <button key={a} type="button" disabled={busyIds?.has(j.id)}
                        onClick={() => onAction(a, j)} data-testid={`lmx-job-${a}-${j.number}`}>
                  {ACTION_LABEL[a]}
                </button>
              ))}
            </span>
          </div>
        );
      })}
    </section>
  );
};

export default LmxJobs;
